import { CustomColumn } from '@components/v2/ui/Datatable/Datatable';
import { TParsedMesurabilityProject } from './api/get-measurability-projects';

const tableSchemaBase: CustomColumn<TParsedMesurabilityProject>[] =
	[
		{
			accessor: 'name',
			title: 'global.project',
			type: 'project',
		},
		{
			accessor: 'type',
			title: 'global.projectType',
			type: 'projectType',
		},
		{
			accessor: 'availableStock',
			title: 'global.availableStock',
			type: 'availableStock',
		},

		{
			accessor: 'sellPrice',
			title: 'global.sellPrice',
			type: 'projectSellPrice',
		},
		{
			accessor: '',
			title: '',
			type: 'projectButtonSeeMore',
		},
	];

export { tableSchemaBase };
